require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-tell-no-tales.json") })
        }
      }, "path---feature-tell-no-tales");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-tell-no-tales!./.cache/json/feature-tell-no-tales.json
// module id = 646
// module chunks = 231608221292675